import ReactDOM from 'react-dom';
import React, { Component } from 'react';
import './index.scss';

class LoadingCom extends Component<any, any> {
  state = {
    show: true,
    text: '',
  }

  componentDidMount() {
    this.setState({
      text: this.props.text,
    });
  }

  /**
   * 显示组件
   */
  show(text: string) {
    this.setState({
      show: true,
      text,
    });
  }

  /**
   * 隐藏组件
   */
  hide() {
    this.setState({
      show: false,
    });
  }

  render() {
    const { show, text } = this.state;
    if (show) {
      return (
        <div className="loadingContainer">
          <div className="loadingImgContainer">
            <div className="loadingImg"></div>
            <div className="loadingInfo">{text}...</div>
          </div>
        </div>
      );
    }
    return null;
  }
}

export default class Loading {
  private static loadingNode;
  private static isShowing = false;

  static show(text: string = '加载中') {
    if (!this.loadingNode) {
      // 新增节点
      const node = document.createElement('div');
      document.body.appendChild(node);
      ReactDOM.render(<LoadingCom text={text} ref={item => this.loadingNode = item} />, node);
    } else {
      // 显示节点
      this.loadingNode.show(text);
    }
    this.isShowing = true;
    this.startMonitor();
  }

  static hide() {
    if (this.loadingNode) {
      this.loadingNode.hide();
      this.isShowing = false;
      this.stopMonitor();
    }
  }

  static monitor: any = null;
  static startMonitor() {
    this.stopMonitor();
    this.monitor = setTimeout(() => {
      if (this.isShowing) {
        this.log();
      }
      this.stopMonitor();
    }, 10000);
  }

  static stopMonitor() {
    this.monitor && clearTimeout(this.monitor);
    this.monitor = null;
  }

  static log() {
  }
}
